package org.ssoft.common.type

sealed class ResolutionStandard(
    override var mask: Int,
    private val pair: Pair<Int, Int>,
    val screenRatio: ScreenRatio
) : Mask {

    val width get() = pair.first
    val height get() = pair.second

    data object UNDEFINED : ResolutionStandard(2, 0 to 0, ScreenRatio._1_1)
    data object HVGA : ResolutionStandard(4, 480 to 320, ScreenRatio._3_2)
    data object VGA : ResolutionStandard(8, 640 to 480, ScreenRatio._4_3)
    data object SVGA : ResolutionStandard(16, 800 to 600, ScreenRatio._4_3)
    data object HD : ResolutionStandard(32, 1280 to 720, ScreenRatio._16_9)
    data object FHD : ResolutionStandard(64, 1920 to 1080, ScreenRatio._16_9)
    data object QHD : ResolutionStandard(128, 2560 to 1440, ScreenRatio._16_9)
    data object UHD : ResolutionStandard(256, 3840 to 2160, ScreenRatio._16_9)


    companion object {

        val all by lazy {
            listOf(
                UNDEFINED,

                HVGA,
                VGA,
                SVGA,
                HD,
                FHD,
                QHD,
                UHD,
            )
        }

        operator fun get(mask: Int): ResolutionStandard = Mask[mask, all] ?: UNDEFINED

    }

    override fun toString(): String = mask.toString()

    override fun hashCode(): Int = mask

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as ResolutionStandard

        return mask == other.mask
    }
}